import { STATUS_BEFORE_SHOOT } from "@/features/schedule/components/detail/rawPhotoPermissions";
import { opsRole } from "@/lib/auth/page-access";

// Ai sửa được thông tin ê-kíp sau khi đơn đã khoá. Gương BE
// ekipschedule.canCorrectLockedWorkInfo — hai bên phải cho cùng câu trả lời
// (spec 2026-08-23 §5.7): TCH mọi phòng; leader / QC chỉ khối ảnh. Vai Điều
// phối khoá 23/08/2026 (quyết định 0050). Thân hàm này soi gương
// `canCorrectLockedRawPhotoLinks` ở
// features/schedule/components/detail/rawPhotoPermissions.ts — sửa một bên
// phải sửa cả hai.
export function canCorrectLockedEkipInfo(
  user:
    | { role?: string | null; department?: string | null; jobTitleCode?: string | null }
    | null
    | undefined,
): boolean {
  // Trưởng ca như Trưởng cửa hàng (QĐ 0425) — gương `auth.OpsRole` bên máy chủ.
  const role = opsRole(user).toLowerCase();
  const dept = (user?.department ?? "").toLowerCase();
  return (
    role === "admin" ||
    role === "director" ||
    role === "branch_manager" ||
    ((role === "manager" || role === "qc") && dept.startsWith("photo"))
  );
}

/**
 * Câu giải thích vì sao ô ghi chú ca và ô thẻ hậu kỳ đang đóng.
 *
 * Câu phải đi theo ĐÚNG lý do đóng (quyết định 0196). Trước đó hộp Công việc in
 * MỘT câu "Ca đã chuyển trạng thái…" cho mọi trạng thái — với đơn còn "Đã đặt"
 * thì câu ấy nói dối: đơn chưa chuyển gì cả. Đó đúng là lỗi người kiểm thử
 * 25/09/2026 báo thành "hệ thống hỏng", chỉ khác ô; mở ô link theo ngày chụp mà
 * để câu này y nguyên là dựng lại lỗi đó ngay bên cạnh.
 */
export function workInfoLockNotice(status: string | null | undefined): string {
  const s = (status ?? "").trim().toLowerCase();
  if (s === "cancelled") return "Đơn đã hủy — không ghi thêm thông tin ca nữa.";
  if (STATUS_BEFORE_SHOOT.has(s)) return "Ghi chú ca và thẻ hậu kỳ mở khi ca bắt đầu chụp.";
  return "Ca đã chuyển trạng thái, cần báo Leader Photo để chỉnh sửa.";
}
